// eslint-disable-next-line no-extra-semi
(function (widgets) {
  var captchaTokenId = null;
  var captchaVersion = '';
  var captchaSiteKey = '';
  var Captcha = widgets.Widget.extend(
    {
      constructor: function CaptchaConstructor(object) {
        mainNav.nextButton.bind(
          'click keypress',
          $.proxy(next_captcha, window, object)
        );
        Captcha.__super__.constructor.call(this, object);
        captchaTokenId = object.token_id;
        captchaVersion = object.version;
        captchaSiteKey = object.RECAPTCHA_SITE_KEY;
        object.locale = window.locale;
        object.RECAPTCHA_DOMAIN = process.env.RECAPTCHA_DOMAIN;
        object.RECAPTCHA_TIMEOUT = 5000;
        object.RECAPTCHA_SCRIPT = captchaVersion.includes('enterprise')
          ? 'enterprise.js'
          : 'api.js';
        object.RECAPTCHA_SCRIPT_PARAMS =
          captchaVersion === 'enterprise-v3'
            ? 'render=' + object.RECAPTCHA_SITE_KEY
            : 'hl=' + object.locale;
        // We want to be able to use execute in the next_captcha function
        if (captchaVersion === 'v3') {
          object.RECAPTCHA_SCRIPT_PARAMS +=
            '&render=' + object.RECAPTCHA_SITE_KEY;
        }

        if (typeof grecaptcha === 'undefined') {
          grecaptcha = {};
        }
      },
      render: function render(object) {
        Captcha.__super__.render.call(this, object);

        /**
         * Checks for the presence of the expected reCAPTCHA `render` method
         * from the Google script after a set time (5 seconds).
         *
         * If no method exists, then it can be assumed the external script
         * never loaded, and we cannot render the captcha.
         *
         **/
        setTimeout(function () {
          if (
            (!grecaptcha.hasOwnProperty('render') &&
              !captchaVersion.includes('enterprise')) ||
            (!grecaptcha.hasOwnProperty('enterprise') &&
              captchaVersion.includes('enterprise'))
          ) {
            // TODO :: Backend (API) needs to be able to handle this value
            // when the script fails to load and cannot send a proper token
            $('input[name=' + captchaTokenId + ']').val('SCRIPT_LOADING_ERROR');
          }
        }, this._object.RECAPTCHA_TIMEOUT);

        window.onVerifyCaptcha = function (token) {
          $('input[name=' + captchaTokenId + ']').val(token);
          if (captchaVersion.includes('v3') && token !== '') {
            click_next({ key: '', type: 'click' });
          }
        };

        if (this._object.version.includes('v3')) {
          $('#captcha_v2_element').css('display', 'none');

          $('#' + mainNav.nextButton.id)
            .attr({
              'data-sitekey': this._object.RECAPTCHA_SITE_KEY,
              'data-callback': 'onVerifyCaptcha',
            })
            .addClass('g-recaptcha');
          $('.nav-buttons').css('display', 'inline-flex');
        }
      },
      destroy: function destroy() {
        var selector = '#' + mainNav.nextButton.id;

        // Garbage collect the reCAPTCHA attributes, <script> tags, and badge
        $(selector)
          .removeAttr('data-sitekey')
          .removeAttr('data-callback')
          .removeClass('g-recaptcha');

        var tags = document.querySelectorAll('script[src*="/recaptcha/"]');
        tags.forEach(function (tag) {
          $(tag).remove();
        });

        // Note: By removing this badge, we cannot support the
        // Back button reloading this widget again
        $('.grecaptcha-badge').parent().remove();

        window.onVerifyCaptcha = $.noop;
      },
    },
    {
      types: ['captcha'],
      views: ['captcha'],
    }
  );

  var next_captcha = function () {
    // Previous token, onVerifyCaptcha won't execute for 'v3'
    // so we need to invoke the challenge manually
    if (
      captchaVersion.includes('v3') &&
      !!page_state.form_data[captchaTokenId] &&
      $('input[name=' + captchaTokenId + ']').val() === ''
    ) {
      let $recaptcha = captchaVersion.includes('enterprise')
        ? grecaptcha.enterprise
        : grecaptcha;

      $recaptcha.ready(function () {
        // Programmatically invoke the challenge
        $recaptcha
          .execute(captchaSiteKey, { action: 'submit' })
          .then(function (token) {
            // Same as onVerifyCaptcha
            $('input[name=' + captchaTokenId + ']').val(token);
            click_next({ key: '', type: 'click' });
          });
      });
      return;
    }

    if (
      captchaVersion.includes('v2') ||
      $('input[name=' + captchaTokenId + ']').val() === 'SCRIPT_LOADING_ERROR'
    ) {
      click_next({ key: '', type: 'click' });
    }
  };

  Captcha.register();
  widgets.Captcha = Captcha;
})((Gryphon.widgets = Gryphon.widgets || {}));
